<template>
  <div>
    <Tables ref="tableGridsTemplateApr"
                :columns= columTemplate
                :showSearch="false"
                :showPrint="false"
                :newHeaderStatus="true"
                :showDownload="false"
                :showFullscreen="false"
                v-on:Load="onLoad">
                <tr v-for="(obj,index) in dataUsuarioAPR" :key="index">
                <TableColumn :IsTextGreen="true"  v-on:Edit="DetailsExpense(obj)" :status="1" :value="obj.codigoAtividade != null ? obj.codigoAtividade: 'N/D'" />
                <TableColumn :IsTextBlue="obj.status === 0 ? true : false" :IsTextOrange="obj.status === 3 ? true : false"  :IsTextDanger="obj.status === 2 ? true : false" :IsTextGreeen="obj.status === 1 ? true : false" v-on:Edit="DetailsExpense(obj)" :status="1" :value="obj.descricaoStatus != null ?  obj.descricaoStatus :  'N/D'" />
                <TableColumn :IsText="true"   v-on:Edit="DetailsExpense(obj)" :status="1" :value="obj.dataCriacao != null ? obj.dataCriacao: 'N/D'" />
                <TableColumn :IsInt="true"   v-on:Edit="DetailsExpense(obj)" :status="1" :value="obj.revisao != null ? obj.revisao : 'N/D'" />
                <TableColumn
                :IsViewExpensesTemplate="true"
                :excluirTemplate="obj.status != 0 "
                v-on:CloneTemplate="popUptAddClonagem(obj)"
                v-on:DetailsExpenseTemplate="DetailsExpense(obj)"
                v-on:editAPRTemplate="popUpEdicao(obj)"
                :IsOnlyAprovaReprova="true"
                v-on:Exclusao="popConfirmacaoExclusao(obj)"
                v-on:aprova="popUpAprovacao(obj)"
                v-on:reprova="popUpReprovcao(obj)"
                />
                </tr>
                <template #ButtonsAprova>
                  <div class="buttons-table-action">
                      <button class="btn-generate-lote-template-apr" @click="popUptAdd">+ NOVO TEMPLATE</button>
                      <button class="btn-generate-lote-template-apr" @click="openFiles"><i class="far fa-file-excel"></i> IMPORTAR PLANILHA</button>
                      <input type="file" v-on:change="imporTable" id="impor-ex-price" itemid="impor-ex">
                  </div>
                </template>
    </Tables>
    <b-modal ref="add-novo-template"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
        <div class="header-title">{{clone != null ?  'CLONAR - ' + numeroAPRTemplate : editar === true ? 'EDITAR TEMPLATE ' +  numeroAPRTemplate :  'NOVO TEMPLATE'}}</div>
    </template>
    <div v-if="liberaClonar === true">
      <p class="font-clone">Apenas os itens que foram aprovados serão clonados!</p>

      <i class="fas fa-exclamation icone-alerta"></i>

      <div class="d-flex container_cancel_save">
          <div class="cancelar">
              <button class="button-cancel" @click="cancelarAddTemplate">CANCELAR</button>
          </div>
          <div class="criar">
            <button class="button-save" @click="avancaClonagem">CONTINUAR</button>
          </div>
      </div>
    </div>
    <div v-else>
        <newTemplate
        @cancelarAddTemplate="cancelarAddTemplate"
        @recarregarTable="recarregarTable"
        :categoria="form.categoria"
        :templateid="templateid"
        :descricao="form.descricao"
        :editar="editar"
        :clone="clone"
        :numeroAPRTemplate="numeroAPRTemplate"
        :clonagemTabela="clonagemTemplate"
        >
        </newTemplate>
    </div>
    </b-modal>

    <b-modal ref="excluir-template"
      size="md"
      centered
      title="novo template"
      :hide-footer="true"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
    >
    <template #modal-title>
        <div class="header-title">Excluir Template</div>
    </template>
    <div>
      <div class="descricao-exclusao">Deseja proseguir com a exclusão do template {{ templateExclusao }}</div>

      <div class="d-flex container_cancel_save">
        <div class="cancelar">
            <button class="button-cancel" @click="cancelarpopConfirmacaoExclusao">CANCELAR</button>
        </div>
        <div class="criar">
          <button class="button-save" @click="removerTemplate">EXCLUIR</button>
        </div>
      </div>
    </div>
    </b-modal>
   </div>

</template>

<script>
import templateTable from './templateTable'
export default templateTable
</script>

  <style scoped>
.icone-alerta {
  display: flex;
  margin: 1rem 0 1rem 0;
  justify-content: center;
  font-size: 55px;
  color: darkgreen;
}
.descricao-exclusao {
  font-weight: bold;
  font-size: 13px;
  text-align: center;
  font-family: 'Segoe UI';
}
.font-clone{
  display: flex;
  justify-content: center;
  color: rgb(128, 128, 128);
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
 }

.button-cancel{
  background-color: #b60000;
  color: white;
}
.button-save{
  background-color: darkgreen;
  color: white;

}
#impor-ex-price{
  display: none;
}
 .novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
 }
 .descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
 }
 .header-title{
  color: white;
  font-weight: bold;
  font-size: 16px;
  font-family: 'Segoe UI';
}
.btn-generate-lote-template-apr {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    width: 163px;
    border: none;
    font-size: 10px;
}
.btn-generate-lote-template-apr:hover{
    background: #024d2a;
    width: 163px;
}
.button-cancel,
.button-save{
  margin-top: 10;
  font-size: 12PX;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

 .container_cancel_save{
  justify-content: center;
  width: 100%;
  margin-top: 1.5rem;
  column-gap: 10px;
 }

.button-cancel{
  background-color: #b60000;
  color: white;
}
.button-save{
  background-color: darkgreen;
  color: white;

}
.buttons-table-action{
  display: flex;
  gap: 1rem;
}
  </style>



// WEBPACK FOOTER //
// src/views/private/apr/templateApr/components/templateTable/templateTable.vue